import { formatBigNumber } from '../../internal/utils/formatBigNumber';
export function parseInputToNumber(input) {
  if (input === '' || input == null) {
    return undefined;
  }
  const parsed = Number(input);
  return isNaN(parsed) ? undefined : parsed;
}
export function validateNumberInRange(value, min, max) {
  if (value === undefined) {
    return undefined;
  }
  let validatedValue = value;
  if (min !== undefined) {
    validatedValue = Math.max(min, validatedValue);
  }
  if (max !== undefined) {
    validatedValue = Math.min(max, validatedValue);
  }
  return validatedValue;
}
export function formatValueForDisplay(value) {
  if (typeof value === 'number' && !isNaN(value)) {
    return formatBigNumber(value);
  }
  return '';
}
export function isSignedRange(min) {
  if (min != null) {
    return min < 0;
  }
  return true;
}